module.exports = require('./helpers/bundle-url').getBundleURL('eVKW7') + "logo-dark.a922e36b.svg";